<template>
    <div v-show="visible"
        class="modal modal--inset modal--fixed"
        :style="styleModalRoot"
    >
        <transition
            v-bind="computedTransition"
            @after-leave="afterCloseModal"
        >
            <div class="modal__wrap" v-if="visibility.modal">
                <div class="modal__overlay" v-if="visibility.modal && cssClass == 'modal__dialog--cities'" @click="close"></div>
                <div :class="['modal__dialog', cssClass]">
                    <button type="button" class="btn modal__close" @click="close"></button>
                    <slot :close="() => close()"></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'modal',
}
</script>

<script setup>
import { ref, reactive, watch, nextTick, computed, onMounted, onBeforeUnmount } from 'vue';
import componentProps from './modal.props';

const emits = defineEmits(["open-modal", "close-modal", "closed"]);
const props = defineProps(componentProps);

const visible = ref(false);
const visibility = reactive({
    modal: false,
    overlay: false
})
const modalIndex = ref(props.index);
const paddingRight = ref(props.dataPadding);

const computedTransition = computed(() => {
    if (typeof props.transition === 'string') return { name: props.transition }
    return { ...props.transition }
})

const calculatedZIndex = computed(() => {
    return +props.zIndex + 2 * modalIndex.value;
})

const styleModalRoot = computed(() => {
    return {
        zIndex: calculatedZIndex.value,
    }
})

onMounted(() => {
    visible.value = true;
    nextTick(() => {
        onOpen()
    })
})

onBeforeUnmount(() => {
    onClose()
})

watch(
    () => props.hideOverlay,
    value => {
        if (props.modelValue && !value) {
            visibility.overlay = true
        }
    }
)

watch(
    () => props.modelValue,
    value => {
        if (!value) {
            onClose()
        }
    }
)

watch(
    () => props.index,
    value => {
        modalIndex.value = value
    }
)

const onOpen = () => {
    if (!props.hideOverlay) {
        visibility.overlay = true;
    }
    visibility.modal = true;
    emits('open-modal');
}

const onClose = () => {
    visibility.overlay = false
    visibility.modal = false
    emits('close-modal');
}

const afterCloseModal = () => {
    emits('closed')
}

const close = () => {
    onClose();
}
</script>